// @ts-ignore
import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "../layouts/sidebar";
import { TopBar } from "../layouts/top-bar";
import { useIsMobile } from "@/hooks/use-mobile";
import { Drawer } from "@/components/Drawer";
import { useSidebar } from "@/contexts/SidebarContext";
import { LicenseBanner } from "@/components/LicenseBanner";
import { YSyncBanner } from "@/components/YSyncBanner";
import { SetupGuideCard } from "@/components/SetupGuideCard";
import { HelpLauncher } from "@/components/support/HelpLauncher";

/**
 * MainLayout: Layout for the main protected app (sidebar, topbar, content).
 */
export default function MainLayout() {
  const isMobile = useIsMobile();
  const { sidebarOpen, setSidebarOpen } = useSidebar();

  return (
    <div className="flex min-h-screen">
      {isMobile ? (
        <Drawer open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <Sidebar />
        </Drawer>
      ) : (
        <Sidebar />
      )}

      <div className="flex-1 min-w-0 flex flex-col">
        <LicenseBanner />
        <YSyncBanner />
        <TopBar />
        <SetupGuideCard />
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
      {/* Boona Help — the support widget's floating launcher (docs/codebase/support/) */}
      <HelpLauncher source="journal" />
    </div>
  );
}
